export function useDateTimeFilters() {
    function date(value: Date) {
        if (!(value instanceof Date)) return value;
        return `${value.getDate().toString().padStart(2, '0')}.${(value.getMonth() + 1).toString().padStart(2, '0')}`;
    }

    function time(value: Date) {
        if (!(value instanceof Date)) return value;
        return `${value.getHours().toString().padStart(2, '0')}:${value.getMinutes().toString().padStart(2, '0')}`;
    }

    return { date, time };
}
